import {
  CREATE_JOB_CARD_ALLOCATION_SUCCESS,
  FETCH_JOB_CARD_ALLOCATION_SUCCESS,
  GET_JOB_CARD_ALLOCATION_SUCCESS,
  GET_LOCATION_BY_QUERY_IN_JOB_CARD_ALLOCATION,
  SAVE_JOB_CARD_ALLOCATION_QUERY,
} from '../../constants/ActionTypes';

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  location: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_JOB_CARD_ALLOCATION_QUERY: {
      return {
        ...state,
        query: action.query,
      };
    }

    case GET_JOB_CARD_ALLOCATION_SUCCESS: {
      const query = { ...state.query };
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      };
    }

    case CREATE_JOB_CARD_ALLOCATION_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      };
    }

    case FETCH_JOB_CARD_ALLOCATION_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      };
    }

    case GET_LOCATION_BY_QUERY_IN_JOB_CARD_ALLOCATION: {
      return {
        ...state,
        location: action.data,
      };
    }


    default:
      return state;
  }
}
